import axios from 'axios'
import { IhLogUrl, ihConfigUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'
import store from '@/store/index'

/**
 * 查询媒体视频列表
 * @param {*} params 用户ID，标签ID，媒体类型，是否重要标记及时间段
 */
export function listMediasTag(params) {
  const url = IhLogUrl + '/mediasTag/page/mediaList'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询媒体视频列表', res)
    }
    // 内外网ip转换
    if (!store.getters.isCloud && res.data && res.data.value && res.data.value.list) {
      let innerIp = store.getters.innerIp
      let outerIp = store.getters.outerIp
      let thisIp = location.hostname
      let replaceFrom = ''
      let replaceTo = ''
      if (thisIp.indexOf(innerIp) > -1) {
        replaceFrom = outerIp
        replaceTo = innerIp
      } else if (thisIp.indexOf(outerIp) > -1 || thisIp.indexOf('localhost') > -1) {
        replaceFrom = innerIp
        replaceTo = outerIp
      }
      if (replaceFrom && replaceTo) {
        res.data.value.list.forEach(item => {
          if (item.mediaUrl) {
            if (item.mediaUrl.indexOf(replaceTo) > -1) {
              return Promise.resolve(res.data)
            }
            item.mediaUrl = item.mediaUrl.replace(replaceFrom, replaceTo)
          }
          if (item.lowMediaUrl) {
            item.lowMediaUrl = item.lowMediaUrl.replace(replaceFrom, replaceTo)
          }
          if (item.preMediaUrl) {
            item.preMediaUrl = item.preMediaUrl.replace(replaceFrom, replaceTo)
          }
          if (item.groupVideoList) {
            item.groupVideoList.forEach(i => {
              if (i.mediaUrl) {
                i.mediaUrl = i.mediaUrl.replace(replaceFrom, replaceTo)
              }
              if (i.lowMediaUrl) {
                i.lowMediaUrl = i.lowMediaUrl.replace(replaceFrom, replaceTo)
              }
              if (i.preMediaUrl) {
                i.preMediaUrl = i.preMediaUrl.replace(replaceFrom, replaceTo)
              }
            })
          }
        })
      }
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 查询媒体视频列表
 * @param {*} params 用户ID，标签ID，媒体类型，是否重要标记及时间段
 */
export function importantListMediasTag(params) {
  const url = IhLogUrl + '/mediasTag/page/all/mediaList'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询媒体重要视频列表', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 下载图片接口
 * @param {*} params
 */
export function downloadPic(path, name) {
  const url = IhLogUrl + '/file/download/' + path + '/' + name

  return axios({
    method: 'get',
    url: url,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || !res.data) {
      errorCollection('实时监控', '下载图片', { status: res.status, data: { state: -1, msg: '下载图片失败' } })
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 图片，视频，音频删除
 * @param {*} params
 */
export function mediasDelete(logTimestamp, type, userId) {
  const url = IhLogUrl + '/medias/delete/' + logTimestamp + '/' + type + '/' + userId

  return axios({
    method: 'delete',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '图片，视频，音频删除', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 图片、视频批量 下载
 * 下载说明：返回zip文件，使用设备序列号+时间戳重命名的zip格式进行下载
 * @param {*} params
 * let params = [
 *   {
 *     userId: userId, // 用户ID
 *     logTimestamp: logTimestamp, // 日志时间
 *     type: type, // 媒体类型 1：视频， 2：图片
 *     groupActual: groupActual, //分组id，图片传空，视频传入groupActual
 *   }
 * ]
 */
export function batchDownloadMedias(params) {
  const url = IhLogUrl + '/medias/batch/download'
  return axios({
    method: 'post',
    url: url,
    data: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || !res.data) {
      errorCollection('实时监控', '图片、视频批量下载', { status: res.status, data: { state: -1, msg: '图片、视频批量下载失败' } })
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 图片，视频，音频，轨迹批量删除
 * @param {*} params
 * let params = [
 *   {
 *     userId: userId, // 用户ID
 *     logTimestamp: logTimestamp, // 日志时间，轨迹传空
 *     type: type, // 媒体类型 0：音频，1：视频， 2：图片， 3：轨迹
 *     groupActual: groupActual/sidGroup, //分组id，图片/音频传空，视频传入groupActual，轨迹传入sidGroup
 *   }
 * ]
 */
export function batchDeleteMedias(params) {
  const url = IhLogUrl + '/medias/batch/delete'
  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '图片，视频，音频，轨迹批量删除', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 图片，视频，轨迹批量标记重要
 * @param {*} params
 * let params = {
 *   ids:[
 *     {
 *       userId: userId, // 用户ID
 *       logTimestamp: logTimestamp,, // 日志时间，轨迹传空
 *       type: type, // 媒体类型 0：音频，1：视频， 2：图片， 3：轨迹
 *       groupActual: groupActual/sidGroup, //分组id，图片/音频传空，视频传入groupActual，轨迹传入sidGroup
 *     }
 *   ],
 *   importantFlag:1 //重要标记 0：非重要，1：重要
 * }
 */
export function batchImportance(params) {
  const url = IhLogUrl + '/medias/batch/importance'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '图片，视频，轨迹批量标记重要', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 轨迹数据删除
 * @param {*} params
 */
export function tranceDelete(userId, sidGroup) {
  const url = IhLogUrl + '/gps/trace/delete/' + userId + '/' + sidGroup

  return axios({
    method: 'delete',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '轨迹数据删除', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 腾讯云视频删除
 * @param {*} params
 */
export function rtcDelete(fileId) {
  const url = ihConfigUrl + '/rtc/delete/' + fileId

  return axios({
    method: 'delete',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '腾讯云视频删除', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 设置重要图片
 * @param {*} params
 */
export function setImpImg(params) {
  const url = IhLogUrl + '/medias/isImportantFlag'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '设置重要图片', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 设置重要轨迹
 * @param {*} params
 */
export function setImpTrack(params) {
  const url = IhLogUrl + '/gps/mark/important'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '设置重要轨迹', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 保存删除媒体数据后台操作记录
 * @param {*} params
 */
export function mediaOperations(params) {
  const url = IhLogUrl + '/operations'

  return axios({
    method: 'POST',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', ' 历史记录删除', res)
    }
    return Promise.resolve(res.data)
  })
}
